import {
  IconButton,
  InputAdornment,
  TextField,
  makeStyles,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useState } from "react";

const CustomTextField = (props) => {
  const {
    id,
    variant = "outlined",
    title,
    value,
    placeholder,
    type = "text",
    onBlur,
    onChange,
    error,
    touched,
    required = false,
    margin = "normal",
    size = "medium",
    min = "0",
    fullWidth = true,
    className,
    multiline,
    rows = 4,
  } = props;

  const { disabled = false, ...newProps } = props;

  const classes = makeStyles((theme) => ({
    errorText: {
      fontSize: theme.typography.body2.fontSize,
    },
    inputText: {
      fontSize: theme.typography.body2.fontSize,
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    rootFieldLabel: {
      color: theme.palette.text.hint,
      fontSize: theme.typography.body2.fontSize,
    },
  }))();

  const [showPassword, setShowPassword] = useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <React.Fragment>
      {type === "password" ? (
        <FormControl
          variant="outlined"
          className={className}
          size={size}
          fullWidth={fullWidth}
          margin={margin}
          disabled={disabled}
        >
          <InputLabel htmlFor={id}>{title}</InputLabel>
          <OutlinedInput
            id={id}
            required={required}
            label={title}
            type={showPassword ? "text" : "password"}
            placeholder={placeholder}
            error={touched && error != null ? true : false}
            onChange={onChange}
            value={value}
            fullWidth={fullWidth}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {error && touched && (
            <FormHelperText className={classes.helperText} id={id + "-helper"}>
              {error}
            </FormHelperText>
          )}
        </FormControl>
      ) : (
        <TextField
          multiline={multiline}
          rows={multiline ? rows : 1}
          {...newProps}
          touched={null}
          id={id}
          required={required}
          className={className}
          variant={variant}
          label={title}
          size={size}
          placeholder={placeholder}
          error={touched && error != null ? true : false}
          name={id}
          onBlur={onBlur}
          onChange={onChange}
          type={type}
          value={value}
          disabled={disabled}
          min={min}
          margin={margin}
          fullWidth={fullWidth}
          helperText={touched && error ? error : null}
          InputLabelProps={{
            classes: {
              root: classes.rootFieldLabel,
            },
          }}
          // InputProps={{
          //   classes: {
          //     root: classes.rootFieldInput,
          //     input: classes.inputText,
          //   },
          // }}
          FormHelperTextProps={{
            classes: {
              root: classes.rootFieldInput,
              error: classes.errorText,
            },
          }}
        />
      )}
    </React.Fragment>
  );
};

export default CustomTextField;
